import { Signer } from 'aws-amplify';
import { AxiosRequestConfig } from 'axios';

export interface InterceptorOptions {
  service: string;
  region: string;
}

export interface ICredentials {
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken?: string;
}

const aws4Interceptor = (options: InterceptorOptions, credentials: ICredentials | (() => ICredentials)) => (cfg: AxiosRequestConfig) => {
  if(!cfg.url) {
    cfg.url = ""
  }
  const request = {
    method: cfg.method?.toUpperCase(),
    url: cfg.url,
    data: cfg.data,
  };
  const currentCredentials = typeof credentials === 'function' ? credentials() : credentials;
  const accessInfo = {
    access_key: currentCredentials.accessKeyId,
    secret_key: currentCredentials.secretAccessKey,
    session_token: currentCredentials.sessionToken,
  };
  const serviceInfo = {
    service: options.service,
    region: options.region,
  };
  const signedRequest = Signer.sign(request, accessInfo, serviceInfo);
  cfg.headers = signedRequest.headers
  return cfg;
};

export default aws4Interceptor;
